<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <p class="f14">当前买手店：{{ vendorName }}<span class="ml20">当前活动： {{ eventName }}</span></p>

    <el-form class="mt15" label-position="right" label-width="40px">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item label="类目">
                <el-select v-model="queryForm.categoryType" clearable>
                  <el-option label="Adult" :value="1"></el-option>
                  <el-option label="Kids" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item label="季节">
                <el-select v-model="queryForm.seasonCodes" multiple collapse-tags clearable>
                  <el-option v-for="item in seasonCodeList" :key="item.seasonCode" :label="item.seasonCode" :value="item.seasonCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" v-if="coFlag">
              <el-form-item label="是否CO" label-width="70px">
                <el-select v-model="queryForm.coFlag" clearable>
                  <el-option label="是" :value="1"></el-option>
                  <el-option label="否" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
          <el-button @click="search" type="primary">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-col>
      </el-row>
    </el-form>

    <div class="toolbar">
      <div>
        <el-button type="primary" @click="showForm" v-if="createBtnDaily" :disabled="status == '1' || status == '5'">新建折扣设置</el-button>
        <el-button type="primary" @click="batchDownload" v-if="downloadBtnDaily" :disabled="selection.length === 0">下载</el-button>
        <el-button type="primary" @click="batchDelete" v-if="deleteBtnDaily" :disabled="selection.length === 0 || status == '1' || status == '5'">删除</el-button>
        <el-button type="primary" @click="showSkuForm">特殊SKU折扣设置</el-button>
      </div>
      <el-button type="primary" v-if="subVendorIs != '1' && configBtnDaily" @click="showConfigForm">活动设置</el-button>
    </div>

    <el-table :data="tableData" @selection-change="handleSelectionChange" v-loading="loading">
      <el-table-column type="selection" width="45"></el-table-column>
      <el-table-column prop="categoryType" label="类目">
        <template slot-scope="scope">
          {{ scope.row.categoryType === 1 ? 'Aduit' : 'Kids' }}
        </template>
      </el-table-column>
      <el-table-column prop="seasonCode" label="季节">
        <template slot-scope="scope">
          {{ scope.row.seasonCode }}{{ scope.row.coFlag ? '(CO)' : '' }}
        </template>
      </el-table-column>
      <el-table-column prop="lastUserName" label="最后更新人"></el-table-column>
      <el-table-column prop="lastUpdatedAt" label="最后更新时间"></el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-link type="primary" @click="showItem(scope.row)">查看</el-link>
          <el-link type="primary" class="ml10" @click="copyItem(scope.row)">复制</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr mt10"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog title="新建折扣设置" :visible.sync="dialogVisible" append-to-body :close-on-click-modal='false' width="800px">
      <el-alert v-if="step === 2" class="mb20" title="注：导入折扣采用全量方式进行覆盖" type="success"></el-alert>
      <p class="f14 tc mb20" v-if="step === 1">折扣比对</p>
      <p class="f14 tc mb20" v-if="step === 2">折扣提交</p>
      <el-form ref="form" :model="form" label-width="80px" v-if="step === 1">
        <el-form-item label="类目" prop="categoryType" :rules="[{ required: true, message: '请选择类目' }]">
          <el-radio-group v-model="form.categoryType" @change="form.compareSeasonCode = null">
            <el-radio :label="1">Adult</el-radio>
            <el-radio :label="2">Kids</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="季节" prop="compareSeasonCode" :rules="[{ required: true, message: '请选择季节' }]">
          <p>没有生效中折扣的季节无法选择</p>
          <el-radio-group v-model="form.compareSeasonCode">
            <template v-if="coFlag">
              <p class="f14 mb10">Carry Over</p>
              <el-radio class="mb10" v-for="item in coSeasonCodeList" :key="item.seasonCode" :label="item" :disabled="form.categoryType == 1 && !item.isHavingAdultDailyDiscount || form.categoryType == 2 && !item.isHavingKidsDailyDiscount">
                {{ item.seasonCode }}
              </el-radio>
              <p class="f14 mb10 mt10">非Carry Over</p>
              <el-radio class="mb10" v-for="item in seasonCodeList" :key="item.seasonCode" :label="item" :disabled="form.categoryType == 1 && !item.isHavingAdultDailyDiscount || form.categoryType == 2 && !item.isHavingKidsDailyDiscount">
                {{ item.seasonCode }}
              </el-radio>
            </template>
            <template v-else>
              <el-radio class="mb10" v-for="item in seasonCodeList" :key="item.seasonCode" :label="item" :disabled="form.categoryType == 1 && !item.isHavingAdultDailyDiscount || form.categoryType == 2 && !item.isHavingKidsDailyDiscount">
                {{ item.seasonCode }}
              </el-radio>
            </template>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="导入文件" prop="fileName" :rules="[{ required: true, message: '请上传文件' }]">
          <div class="upload-container">
            <div class="upload-btn">
              <el-button type="primary" icon="el-icon-upload" size="medium" plain>添加文件</el-button>
              <input @change="changeFile" accept=".xlsx,.xls" type="file" />
            </div>
            <el-button type="text" @click="downloadTemplate">下载文件模板</el-button>
          </div>
          <p class="supply-tip">支持扩展名：.xls .xlxs</p>
          <template v-if="form.fileName">
            <div class="file-item bg-gray"><i class="el-icon-document"></i> {{ showFileName }}</div>
            <el-button class="ml10" type="text" size="mini" @click="form.fileName = null; showFileName=''">删除</el-button>
          </template>
        </el-form-item>
      </el-form>
      <el-form ref="form2" :model="form" label-width="80px" v-if="step === 2">
        <el-form-item label="导入文件">{{ showFileName }}</el-form-item>
        <el-form-item label="季节" prop="seasonCodeList" :rules="[{ required: true, message: '请选择季节' }]">
          <el-checkbox-group v-model="form.seasonCodeList">
            <template v-if="coFlag">
              <p class="f14 mb10">Carry Over</p>
              <el-checkbox class="mb10" v-for="item in coSeasonCodeList" :key="item.seasonCode" :label="item" :disabled="form.categoryType == 1 && !item.isHavingAdultDailyDiscount || form.categoryType == 2 && !item.isHavingKidsDailyDiscount">
                {{ item.seasonCode }}
              </el-checkbox>
              <p class="f14 mb10 mt10">非Carry Over</p>
              <el-checkbox class="mb10" v-for="item in seasonCodeList" :key="item.seasonCode" :label="item" :disabled="form.categoryType == 1 && !item.isHavingAdultDailyDiscount || form.categoryType == 2 && !item.isHavingKidsDailyDiscount">
                {{ item.seasonCode }}
              </el-checkbox>
            </template>
            <template v-else>
              <el-checkbox class="mb10" v-for="item in seasonCodeList" :key="item.seasonCode" :label="item" :disabled="form.categoryType == 1 && !item.isHavingAdultDailyDiscount || form.categoryType == 2 && !item.isHavingKidsDailyDiscount">
                {{ item.seasonCode }}
              </el-checkbox>
            </template>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="step === 1" @click="dialogVisible = false">取 消</el-button>
        <el-button v-if="step === 2" @click="prev">上一步</el-button>
        <el-button type="primary" v-if="step === 1" @click="next">下一步</el-button>
        <el-button type="primary" v-if="step === 2" @click="submit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="复制" :visible.sync="dialogVisible2" append-to-body :close-on-click-modal='false' width="800px">
      <p class="f14 mb20">
        <span>当前类目：{{ copyForm.categoryType === 1 ? 'Adult' : 'Kids' }}</span>
        <span class="ml20">当前季节：{{ copyForm.seasonCode }}{{ copyForm.coFlag ? '(CO)' : '' }}</span>
        <span class="ml20">当前活动：{{ eventName }}</span>
      </p>
      <el-form ref="copyForm" :model="copyForm" label-width="80px">
        <el-form-item label="季节" prop="seasonCodeList" :rules="[{ required: true, message: '请选择季节' }]">
          <p>没有生效中折扣的季节无法选择</p>
          <el-checkbox-group v-model="copyForm.seasonCodeList">
            <template v-if="coFlag">
              <p class="f14 mb10">Carry Over</p>
              <template v-for="item in coSeasonCodeList">
                <el-checkbox class="mb10" :key="item.seasonCode" :label="item" v-if="!(copyForm.selfSeasonCode == item.seasonCode && copyForm.coFlag == 1)" :disabled="copyForm.categoryType == 1 && !item.isHavingAdultDailyDiscount || copyForm.categoryType == 2 && !item.isHavingKidsDailyDiscount || copyForm.selfSeasonCode == item.seasonCode && copyForm.coFlag == 1">
                  {{ item.seasonCode }}
                </el-checkbox>
              </template>
              <p class="f14 mb10 mt10">非Carry Over</p>
              <template v-for="item in seasonCodeList">
                <el-checkbox class="mb10" :key="item.seasonCode" :label="item" v-if="!(copyForm.selfSeasonCode == item.seasonCode && copyForm.coFlag == 0)" :disabled="copyForm.categoryType == 1 && !item.isHavingAdultDailyDiscount || copyForm.categoryType == 2 && !item.isHavingKidsDailyDiscount || copyForm.selfSeasonCode == item.seasonCode && copyForm.coFlag == 0">
                  {{ item.seasonCode }}
                </el-checkbox>
              </template>
            </template>
            <template v-else>
              <template v-for="item in seasonCodeList">
                <el-checkbox class="mb10" :key="item.seasonCode" :label="item" v-if="copyForm.selfSeasonCode != item.seasonCode" :disabled="copyForm.categoryType == 1 && !item.isHavingAdultDailyDiscount || copyForm.categoryType == 2 && !item.isHavingKidsDailyDiscount || copyForm.selfSeasonCode == item.seasonCode">
                  {{ item.seasonCode }}
                </el-checkbox>
              </template>
            </template>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="submitCopyForm">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="活动设置" :visible.sync="dialogVisible3" append-to-body :close-on-click-modal='false' width="550px">
      <div v-loading="configLoading">
        <el-alert class="mb20" title="注：请在折扣提报前完成活动设置" type="success"></el-alert>
        <el-checkbox class="checkbox-item mb15" v-model="configForm.autoSubmitted">自动提报新商品</el-checkbox>
        <el-checkbox class="checkbox-item mb15" v-model="configForm.promotionContinue">活动结束后活动折扣继续执行</el-checkbox>
        <el-form label-width="140px">
          <el-form-item label="活动价格生效范围：">
            <el-radio-group v-model="configForm.supplyPriceActivateType">
              <el-radio class="checkbox-item mt15" :label="1" :true-label="1" :false-label="0">活动开始后生效</el-radio>
              <el-radio class="checkbox-item mt15" :label="2" :true-label="1" :false-label="0">立即生效</el-radio>
              <el-radio :label="3">
                指定时间开始生效
                <el-date-picker
                  :disabled="configForm.supplyPriceActivateType !== 3"
                  v-model="configForm.supplyPriceActivateTime"
                  :picker-options="pickerOptions"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm"
                  value-format="timestamp">
                </el-date-picker>
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" v-if="!(status == '1' || status == '5')" :loading="configSubmitLoading" @click="submitConfigForm">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="上传" :visible.sync="dialogVisible4" append-to-body :close-on-click-modal='false' width="550px">
      <p class="f24 tc bold green" v-if="analysisSuccess">比对成功</p>
      <p class="f24 tc bold red" v-else>{{analysisCode == '1304'?'文件解析失败':'比对失败'}}</p>
      <p v-if="analysisCode == '1301'">比对文件相同，请重新上传正确的文件</p>
      <p v-if="analysisCode == '1302'" class="red">当前文件行数过多，仅比对二级，三级类目折扣</p>
      <p v-if="analysisCode == '1303'" class="red">当前文件行数过多，仅比对二级类目折扣</p>
      <p v-if="analysisSuccess"><el-link type="primary" @click="downloadUrlFile(analyUrl)">下载文件对比结果</el-link></p>
      <p v-if="!analysisSuccess && !analysisCode && analysisMessage" class="red">{{ analysisMessage }}</p>
      <p v-if="analysisCode == '1304'"><el-link type="primary" @click="downloadUrlFile(analyUrl)">下载文件解析结果</el-link>（请根据错误原因更新文件后重新提交）</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible4 = false">取 消</el-button>
        <el-button type="primary" v-if="analysisCode != '1304'" @click="submitFile">下一步</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import utils from '@/utils/util.js'
import Client from "@/utils/client.js";
import { downloadUrlFile } from '@/utils/functions';
import {
  fileUpload,
  getPromotionVendorDiscountSeason,
  getVendorPromotionDiscountList,
  getPromotionVendorDiscountTemplate,
  analysisPromotionVendorDiscount,
  createPromotionVendorDiscount,
  copyPromotionVendorDiscount,
  downloadPromotionVendorDiscount,
  deletePromotionVendorDiscount,
  getPromotionVendorDiscountConfig,
  savePromotionVendorDiscountConfig,
} from "../api.js";

export default {
  data() {
    return {
      fullscreenLoading: false,
      vendorName: this.$route.query.name,
      eventName: this.$route.query.eventName,
      coFlag: this.$route.query.coFlag ? Number(this.$route.query.coFlag) : 0,
      subVendorIs: this.$route.query.subVendorIs,
      status: this.$route.query.status,
      coSeasonCodeList: [],
      seasonCodeList: [],
      loading: false,
      queryForm: {
        categoryType: null,
        seasonCodes: [],
        coFlag: null,
        pageNo: 1,
        pageSize: 25,
      },
      tableData: [],
      total: 0,
      selection: [],
      dialogVisible: false,
      showFileName: '',
      form: {
        salesPromotionVendorRuleSeasonId: null,
        salesPromotionId: this.$route.params.id,
        categoryType: 1,
        compareSeasonCode: null,
        fileName: null,
        seasonCodeList: [],
      },
      step: 1,
      dialogVisible2: false,
      copyForm: {
        salesPromotionVendorRuleSeasonId: null,
        selfSeasonCode: null,
        categoryType: null,
        seasonCode: '',
        coFlag: 1,
        seasonCodeList: [],
      },
      dialogVisible3: false,
      configLoading: false,
      configForm: {
        autoSubmitted: true,
        promotionContinue: false,
        supplyPriceActivateTime: null,
        supplyPriceActivateType: 1,
      },
      configSubmitLoading: false,
      pickerOptions: {
        disabledDate: (time) => time < new Date(Date.now() - 24 * 60 * 60 * 1000),
      },
      dialogVisible4: false,
      analyUrl: null,
      analysisSuccess: false,
      analysisCode: null,
      analysisMessage: null,
    };
  },
  computed: {
    ...mapState({
      createBtnDaily: (state) => state.app.menuMap['折扣管理-活动折扣-新建'],
      downloadBtnDaily: (state) => state.app.menuMap['折扣管理-活动折扣-下载'],
      deleteBtnDaily: (state) => state.app.menuMap['折扣管理-活动折扣-删除'],
      configBtnDaily: (state) => state.app.menuMap['折扣管理-活动折扣-活动设置'],
    }),
  },
  created() {
    this.getPromotionVendorDiscountSeason();
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.categoryType = null;
      this.queryForm.seasonCodes = [];
      this.queryForm.coFlag = null;
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      getVendorPromotionDiscountList(this.$route.params.vendorId, this.$route.params.id, this.queryForm).then(res => {
        if (res.data) {
          this.total = res.data.total;
          this.tableData = res.data.list;
        }
        this.loading = false;
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    dateFormat(time) {
      if (!time) {
        return '';
      }
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd hh:mm');
    },
    batchDownload() {
      if (this.selection.length === 0) {
        return;
      }
      this.fullscreenLoading = true;
      downloadPromotionVendorDiscount(this.$route.params.vendorId, this.selection.map(item => item.salesPromotionVendorRuleSeasonId)).then(res => {
        this.fullscreenLoading = false;
        if (res.data) {
          downloadUrlFile(res.data);
        }
      }).catch(() => {
        this.fullscreenLoading = false;
      });
    },
    batchDelete() {
      if (this.selection.length === 0) {
        return;
      }
      this.$confirm('确认删除选中季节的折扣设置？删除后，选中季节的商品将全部退出活动', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.fullscreenLoading = true;
        deletePromotionVendorDiscount(this.$route.params.vendorId, this.selection.map(item => item.salesPromotionVendorRuleSeasonId)).then(res => {
          this.fullscreenLoading = false;
          if (res.success) {
            this.$message.success('删除成功');
            this.getTableData();
          } else {
            this.$message.error(res.message || '系统异常，请稍后再试');
          }
        }).catch(() => {
          this.fullscreenLoading = false;
        });
      }).catch(() => { });
    },
    getPromotionVendorDiscountSeason() {
      getPromotionVendorDiscountSeason(this.$route.params.vendorId, {
        salesPromotionId: this.$route.params.id,
      }).then((res) => {
        if (res.data) {
          this.seasonCodeList = res.data.seasonCodeList;
          this.coSeasonCodeList = res.data.coSeasonCodeList;
        }
      })
    },
    showForm() {
      this.getPromotionVendorDiscountSeason();
      this.step = 1;
      this.form.salesPromotionVendorRuleSeasonId = null;
      this.form.categoryType = 1;
      this.form.compareSeasonCode = null;
      this.form.fileName = null;
      this.showFileName = '';
      this.form.seasonCodeList = [];
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    showSkuForm(){
      let routeData = this.$router.resolve({
        path: '/discount/promotion/sku',
        query: {
          salesPromotionId: this.$route.params.id,
          vendorId: this.$route.params.vendorId,
        }
      });
      window.open(routeData.href, "_blank");
    },
    downloadTemplate() {
      getPromotionVendorDiscountTemplate(this.$route.params.vendorId, { categoryType: this.form.categoryType }).then(res => {
        if (res.data) {
          downloadUrlFile(res.data);
        }
      });
    },
    async changeFile(e) {
      if (e && e.target && e.target.files && e.target.files[0]) {
        const file = e.target.files[0];
        if (!/\.xlsx?$/.test(String(file.name).toLowerCase())) {
          this.$message.error('只能上传.xls .xlsx格式');
          return;
        }
        if (file.size > 50 * 1024 * 1024) {
          this.$message.error('文件太大了');
          return;
        }
        this.fullscreenLoading = true;
        this.showFileName = file.name;
        const confRes = await fileUpload();
        const OSSClient = Client(confRes.data);
        const fileName = this.random_string(6) + '_' + new Date().getTime() + '.' + file.name.split('.').pop();
        const random_name = 'tmp/' + fileName;
        const res = await OSSClient.put(random_name, file);
        this.form.fileName = res.url;
        this.fullscreenLoading = false;
      }
      e.target.value = '';
    },
    random_string(len) {
      len = len || 32;
      let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678', maxPos = chars.length, pwd = '';
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    showItem(row) {
      let routeData = this.$router.resolve({
        path: '/discount/detail/promotion',
        query: {
          id: row.salesPromotionVendorRuleSeasonId,
          status: this.status,
          categoryType: row.categoryType,
          season: row.seasonCode,
          name: this.vendorName,
          eventName: this.eventName,
          co: row.coFlag,
          page: 'promotion',
        }
      });
      window.open(routeData.href, "_blank");
    },
    prev() {
      this.step = 1;
    },
    async next() {
      const valid = await this.$refs.form.validate();
      if (!valid) {
        this.$message('请完善信息');
        return;
      }
      if (this.repeatSubmit) {
        return;
      }
      this.repeatSubmit = true;
      this.fullscreenLoading = true;
      analysisPromotionVendorDiscount(this.$route.params.vendorId, this.form).then(res => {
        this.analysisCode = res.code;
        this.analysisSuccess = res.success;
        this.analysisMessage = res.message;
        this.analyUrl = res.data;
        this.dialogVisible4 = true;
        this.repeatSubmit = false;
        this.fullscreenLoading = false;
      }).catch(() => {
        this.fullscreenLoading = false;
        setTimeout(() => {
          this.repeatSubmit = false;
        }, 2000);
      })
    },
    async submit() {
      const valid = await this.$refs.form2.validate();
      if (!valid) {
        this.$message('请完善信息');
        return;
      }
      const arr = this.showFileName.split('#').map(item => {
        const temp = item.trim();
        return temp.toUpperCase();
      });
      if (arr[2]) {
        arr[2] = arr[2].replace('（', '(');
        arr[2] = arr[2].replace('）', ')');
      }
      if (arr[0] != this.vendorName.toUpperCase()) {
        this.$message.error('上传文件的店铺名称与当前实际操作的店铺名称不一致，请修改后上传')
        return;
      }
      if (this.form.seasonCodeList.length === 1) {
        let seasonCode = this.form.seasonCodeList[0].seasonCode.toUpperCase();
        if (this.form.seasonCodeList[0].coFlag) {
          seasonCode += '(CO)';
        }
        if (!arr[2] || seasonCode != arr[2]) {
          this.$message.error('上传文件的季节与当前实际操作的季节不一致，请修改后上传');
          return;
        }
      }
      if (this.repeatSubmit) {
        return;
      }
      this.repeatSubmit = true;
      this.fullscreenLoading = true;
      createPromotionVendorDiscount(this.$route.params.vendorId, this.form).then(res => {
        this.fullscreenLoading = false;
        if (res.success) {
          this.$message.success('新建成功');
          this.dialogVisible = false;
          this.getTableData();
        } else {
          this.$message.error(res.message || '系统异常，请稍后再试');
        }
        setTimeout(() => {
          this.repeatSubmit = false;
        }, 2000);
      }).catch(() => {
        this.fullscreenLoading = false;
        setTimeout(() => {
          this.repeatSubmit = false;
        }, 2000);
      });
    },
    submitFile() {
      this.step = 2;
      this.dialogVisible4 = false;
    },
    copyItem(row) {
      this.getPromotionVendorDiscountSeason();
      this.copyForm.salesPromotionVendorRuleSeasonId = row.salesPromotionVendorRuleSeasonId;
      this.copyForm.selfSeasonCode = row.seasonCode;
      this.copyForm.categoryType = row.categoryType;
      this.copyForm.seasonCode = row.seasonCode;
      this.copyForm.coFlag = row.coFlag;
      this.copyForm.seasonCodeList = [];
      this.dialogVisible2 = true;
      this.$nextTick(() => {
        this.$refs.copyForm.clearValidate();
      });
    },
    async submitCopyForm() {
      const valid = await this.$refs.copyForm.validate();
      if (!valid) {
        this.$message('请完善信息');
        return;
      }
      const result = await this.$confirm('确认提交？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      });
      if (!result) {
        return;
      }
      if (this.repeatSubmit) {
        return;
      }
      this.repeatSubmit = true;
      this.fullscreenLoading = true;
      copyPromotionVendorDiscount(this.$route.params.vendorId, this.copyForm).then(res => {
        this.fullscreenLoading = false;
        if (res.success) {
          this.$message.success('复制成功');
          this.dialogVisible2 = false;
          this.getTableData();
        } else {
          this.$message.error(res.message || '系统异常，请稍后再试');
        }
        setTimeout(() => {
          this.repeatSubmit = false;
        }, 2000);
      }).catch(() => {
        this.fullscreenLoading = false;
        setTimeout(() => {
          this.repeatSubmit = false;
        }, 2000);
      });
    },
    showConfigForm() {
      this.configLoading = true;
      getPromotionVendorDiscountConfig(this.$route.params.vendorId, this.$route.params.id).then(res => {
        if (res.data) {
          if (res.data.autoSubmitted === null) {
            res.data.autoSubmitted = true;
          }
          if (res.data.supplyPriceActivateType === null) {
            res.data.supplyPriceActivateType = 1
          }
          this.configForm.autoSubmitted = res.data.autoSubmitted;
          this.configForm.promotionContinue = res.data.promotionContinue;
          this.configForm.supplyPriceActivateType = res.data.supplyPriceActivateType;
          this.configForm.supplyPriceActivateTime = res.data.supplyPriceActivateTime;
        }
        this.configLoading = false;
      })
      this.dialogVisible3 = true;
    },
    submitConfigForm() {
      if (this.configForm.supplyPriceActivateType === 3) {
        if (!this.configForm.supplyPriceActivateTime) {
          this.$message('请选择时间');
          return;
        }
        if (Date.now() >= this.configForm.supplyPriceActivateTime) {
          this.$message('时间必须大于当前时间');
          return;
        }
        if (new Date(this.$route.query.activityStartTime).getTime() <= this.configForm.supplyPriceActivateTime) {
          this.$message.info('时间必须小于活动开始时间')
          return;
        }
      }
      if (this.repeatSubmit) {
        return;
      }
      this.repeatSubmit = true;
      this.configSubmitLoading = true;
      savePromotionVendorDiscountConfig(this.$route.params.vendorId, this.$route.params.id, {
        ...this.configForm,
        supplyPriceActivateTime: this.configForm.supplyPriceActivateType === 3 ? this.configForm.supplyPriceActivateTime : null,
      }).then(res => {
        this.configSubmitLoading = false;
        if (res && res.success) {
          this.$message.success('设置成功')
          this.dialogVisible3 = false;
        } else {
          this.$message.warning(res.message)
        }
        setTimeout(() => {
          this.repeatSubmit = false;
        }, 2000);
      }).catch(() => {
        this.configSubmitLoading = false;
        setTimeout(() => {
          this.repeatSubmit = false;
        }, 2000);
      });
    },
    downloadUrlFile(url) {
      downloadUrlFile(url);
    },
  },
};
</script>
<style lang="less" scoped>
.f14 {
  font-size: 14px;
}
.f24 {
  font-size: 24px;
}
.bold {
  font-weight: bold;
}
.red {
  color: #F56C6C;
}
.green {
  color: #67C23A;
}
.gray {
  color: #909399;
}
.pl10 {
  padding-left: 10px;
}
.mt10 {
  margin-top: 10px;
}
.mt15 {
  margin-top: 15px;
}
.mt20 {
  margin-top: 20px;
}
.mb0 {
  margin-bottom: 0;
}
.mb10 {
  margin-bottom: 10px;
}
.mb15 {
  margin-bottom: 15px;
}
.mb20 {
  margin-bottom: 20px;
}
.ml10 {
  margin-left: 10px;
}
.ml20 {
  margin-left: 20px;
}
.tr {
  text-align: right;
}
.tc {
  text-align: center;
}
.shoppe {
  padding: 20px;
}
.status-point {
  display: inline-block;
  width: 6px;
  height: 6px;
  margin-right: 3px;
  background-color: #F56C6C;
  border-radius: 6px;

  &.green {
    background-color: #67C23A;
  }
  &.gray {
    background-color: #909399;
  }
}
.mt30 {
  margin-top: 30px;
}
.toolbar {
  display: flex;
  justify-content: space-between;
}

.upload-container {
  display: flex;

  .upload-btn {
    position: relative;
    margin-right: 50px;

    input {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
}
.bg-gray {
  background-color: #f2f2f2;
}
.supply-tip {
  margin-top: 10px;
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}
.file-item {
  display: inline-block;
  padding: 5px 10px;
  margin-top: 10px;
  border-radius: 4px;
  line-height: 1.5;
}
.checkbox-item {
  display: block;
}
</style>
